const licenseStatusTrial = 'Trial';
const licenseStatusFree = 'Free';
const licenseStatusFull = 'Full';

const pkgNone = '';
const pkgFree = 'Brixx Free';
const pkgTrial = 'Trial';

const pkgSingle = 'Brixx'

export class LicensePackageType {
    public static None = pkgNone;
    public static BrixxFree = pkgFree;
    public static Trial = pkgTrial;
    public static BrixxSingle = pkgSingle;
}

export class LicenseStatus {
    public static Trial = licenseStatusTrial;
    public static Free = licenseStatusFree;
    public static Full = licenseStatusFull;
}

export interface IPackageOption {
    // Avangate package option name
    OptionName: string;
    // Avangate package option unique code
    UniqueCode: string;
}

export const LicensePackageOptions: Map<string, IPackageOption> = new Map([
    [pkgNone, { OptionName: '', UniqueCode: '' }],
    [pkgTrial, { OptionName: 'Trial', UniqueCode: '' }],
    [pkgFree, { OptionName: 'Foundations', UniqueCode: 'BrixxFree' }],
    [pkgSingle, {OptionName: 'Brixx', UniqueCode: 'Brixx'}]
]);

export type LicensePackage = keyof typeof LicensePackageType
